import { render, staticRenderFns } from "./3_AddressDetails.vue?vue&type=template&id=a2e73a14&"
import script from "./3_AddressDetails.vue?vue&type=script&lang=js&"
export * from "./3_AddressDetails.vue?vue&type=script&lang=js&"
import style0 from "./3_AddressDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports